// Swiper Slider Settings

document.addEventListener('DOMContentLoaded', function () {
  // Initialize bundle pricing immediately to prevent blinking
  const hasBundleFeature = document.querySelector('.bundle-tabs') || document.querySelector('.bundle-tab__button');
  if (hasBundleFeature) {
    window.upadtePrice();
  }
  
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
      
        768: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');
    
    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');
      
      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});


// Thumbail Slider for Bundle Feature Product
function initSwiperSliderForBundleFeatureProduct(element){
  
  const isNotProductPage = document.querySelector('.product-template-bundle') === null;
  const isProductPage = document.querySelector('.product-template-bundle');
  
  // Only initialize swiper if we're not on a product page
  if (isNotProductPage) {
    var swiper = new Swiper(element, {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      pagination: {
          el: '.swiper-pagination',
          clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  
  const tabButtons = document.querySelectorAll('.bundle-tab__button');
  const tabContents = document.querySelectorAll('.bundle-tab__content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
  
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const tabContent = document.querySelector(`[data-tab-content="${button.dataset.tab}"]`);
      tabContent?.classList.add('active');      

      // Change the image on click of button 
      if (isProductPage) {
        const productImages = document.querySelectorAll('.template--care-subscription-bundle .thumbnail-list__item');
        productImages.forEach(function (imageWrapper) {
          const imageEleAlt = imageWrapper.querySelector('img').getAttribute('alt');
          if (imageEleAlt == button?.getAttribute('data-tab-text').toLowerCase()) {
            const imageParent = imageWrapper.querySelector('img').closest('.thumbnail');
            imageParent.click();
          }
        })
      }
      
      // Only handle image switching if we're not on a product page
      if (isNotProductPage) {
        element.querySelectorAll('.product__media-item-new').forEach(function(Ele){        
          let ImageAlt = Ele.getAttribute('data-image-alt');     
          if(ImageAlt == button?.getAttribute('data-tab-text')?.toLowerCase()){
            ImageIndex = Ele.getAttribute('data-index');     
            swiper.slideTo(ImageIndex,1000,false);
          }              
        });
      }
      console.log('Tab clicked, calling upadtePrice');
      window.upadtePrice();
    });
  });
  
  // Initialize bundle pricing on page load to prevent blinking
  setTimeout(() => {
    window.upadtePrice();
  }, 100);
}

window.tabChange = function () {
  const tabButtons = document.querySelectorAll('.bundle-tab__button');
  const tabContents = document.querySelectorAll('.bundle-tab__content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
  
      button.classList.add('active');
      const tabContent = document.querySelector(`[data-tab-content="${button.dataset.tab}"]`);
      tabContent?.classList.add('active');      

      if (isProductPage) {
        const productImages = document.querySelectorAll('.template--care-subscription-bundle .thumbnail-list__item');
        productImages.forEach(function (imageWrapper) {
          const imageEleAlt = imageWrapper.querySelector('img').getAttribute('alt');
          if (imageEleAlt == button.getAttribute('data-tab-text').toLowerCase()) {
            const imageParent = imageWrapper.querySelector('img').closest('.thumbnail');
            imageParent.click();
          }
        })
      }
    
      if (isNotProductPage) {
        element.querySelectorAll('.product__media-item-new').forEach(function(Ele){        
          let ImageAlt = Ele.getAttribute('data-image-alt');     
          if(ImageAlt == button.getAttribute('data-tab-text').toLowerCase()){
            ImageIndex = Ele.getAttribute('data-index');     
            swiper.slideTo(ImageIndex,1000,false);
          }              
        });
      }
      console.log('Tab clicked, calling upadtePrice');
      window.upadtePrice();
    });
  });
}

document.addEventListener('DOMContentLoaded', ()=>{
  const AllBundleFeatureProduct = document.querySelectorAll('.js-product-media-items');
  if(AllBundleFeatureProduct.length > 0){
    AllBundleFeatureProduct.forEach(bundleProduct=>{
      initSwiperSliderForBundleFeatureProduct(bundleProduct);
    })
  }
})


// document.addEventListener('DOMContentLoaded', function() {
//     const tabButtons = document.querySelectorAll('.bundle-tab__button');
//     const tabContents = document.querySelectorAll('.bundle-tab__content');

//     tabButtons.forEach(button => {
//       button.addEventListener('click', () => {
//         // Remove active class from all buttons and contents
//         tabButtons.forEach(btn => btn.classList.remove('active'));
//         tabContents.forEach(content => content.classList.remove('active'));

//         // Add active class to clicked button and corresponding content
//         button.classList.add('active');
//         const tabContent = document.querySelector(`[data-tab-content="${button.dataset.tab}"]`);
//         tabContent.classList.add('active');
//       });
//     });
//   });


// Quick cart JS for PDP

window.addEventListener('scroll', function () {
  const formSubmitButton = document.querySelector('.product-form .product-form__submit');
  const activeButton = document.querySelector('.bundle-tab__content.active [data-bundle-submit]');
  const isFormSubmitVisible = formSubmitButton && isElementVisible(formSubmitButton);
  const isActiveButtonVisible = activeButton && isElementVisible(activeButton);
  if (isFormSubmitVisible || isActiveButtonVisible) {
    document.body.classList.remove('sticky-cart-wrapper');
  } else {
    document.body.classList.add('sticky-cart-wrapper');
  }
});

function isElementVisible(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= window.innerHeight;
}

if (!customElements.get('sticky-quick-cart')) {
  customElements.define('sticky-quick-cart', class ProductForm extends HTMLElement {
      constructor() {
          super();
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          
          var variant_selector = document.getElementById('variantSelect');
          if (variant_selector) {
          }
          this.hideErrors = this.dataset.hideErrors === 'true';
      } 

      connectedCallback() {
          this.setupStickyCartListener();
      }

      setupStickyCartListener() {
          this.submitButton.replaceWith(this.submitButton.cloneNode(true));
          this.submitButton = this.querySelector('[type="submit"]');
          const ATCbutton = document.querySelector('.bundle-tab__content.active [data-bundle-submit]') || document.querySelector('.product-form .product-form__buttons .product-form__submit');
          if (ATCbutton != null) {
              this.submitButton.addEventListener('click', function(e) {
                  e.preventDefault();
                  ATCbutton.click();
              });
          }
          
          document.addEventListener('click', (e) => {
              if (e.target.classList.contains('bundle-tab__button')) {
                  setTimeout(() => {
                      this.setupStickyCartListener();
                  }, 100);
              }
          });
      }
  });
}

// window.bundleCheckout = function (){
//  const bundleForms = document.querySelectorAll('[data-bundle-form]');    
//   bundleForms.forEach(form => {
//     form.addEventListener('click', function(e) {
//       e.preventDefault();
 
//       const variant_id = form.querySelector('input[name="id"]').value;
//       const quantity = parseInt(form.querySelector('input[name="quantity"]').value);
//       const selling_plan = form.querySelector('input[name="selling_plan"]').value;
//       // const plan_discount = form.querySelector('input[name="discount_value"]').value;
     
//       const submitButton = form.querySelector('[data-bundle-submit]');
//       const originalText = submitButton.innerHTML;
//       submitButton.innerHTML = 'Adding...';
//       submitButton.disabled = true;  
 
//       setTimeout(function() {
//         submitButton.innerHTML = originalText;
//         submitButton.disabled = false;
//       }, 1000);
     
//       window.location.href = `/cart/add?items[][id]=${variant_id}&items[][quantity]=${quantity}&items[][selling_plan]=${selling_plan}&return_to=/checkout`;
//     });
//   });
// }
// window.bundleCheckout();

window.bundleCheckout = function () {
  const bundleForms = document.querySelectorAll('[data-bundle-form]');

  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  function updateCartCount(count) {
    const selectors = ['[data-cart-count]', '.cart-count', '.header__cart-count', '#CartCount'];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = count;
        if (el.dataset) el.dataset.count = count;
      });
    });
  }
  function replaceDrawerHtml(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const drawerSelectors = ['cart-drawer', '.cart-drawer', '#CartDrawer', '.drawer--cart'];
    for (const sel of drawerSelectors) {
      const newDrawer = temp.querySelector(sel);
      const oldDrawer = document.querySelector(sel);
      if (newDrawer && oldDrawer) {
        oldDrawer.replaceWith(newDrawer);
        return true;
      }
    }
    const old = document.querySelector('.cart-drawer, cart-drawer, #CartDrawer');
    const newInner = temp.querySelector('.cart-drawer, cart-drawer, #CartDrawer');
    if (old && newInner) {
      old.innerHTML = newInner.innerHTML;
      return true;
    }
    return false;
  }

  // Handle cart drawer close button clicks - works even after HTML replacement
  function setupCartDrawerCloseHandler() {
    document.addEventListener('click', function(evt) {
      const target = evt.target;
      const closeButton = target.closest && target.closest('.drawer__close');
      const overlay = target.id === 'CartDrawer-Overlay' ? target : null;
      
      if (closeButton || overlay) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.close === 'function') {
          evt.preventDefault();
          evt.stopPropagation();
          cartDrawer.close();
        } else {
          // Fallback: directly remove classes if close method doesn't exist
          const drawerElement = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
          if (drawerElement) {
            evt.preventDefault();
            evt.stopPropagation();
            drawerElement.classList.remove('active', 'is-open');
            document.body.classList.remove('overflow-hidden');
          }
        }
      }
    });
  }
  
  // Initialize cart drawer close handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartDrawerCloseHandler);
  } else {
    setupCartDrawerCloseHandler();
  }
  function tryFetchDrawerHtml() {
    const urls = [
      '/cart?view=drawer',
      '/?sections=cart-drawer',
      '/cart?sections=cart-drawer',
      '/cart' 
    ];

    return urls.reduce((p, url) => {
      return p.catch(() => fetch(url).then(r => {
        if (!r.ok) throw new Error('no html');
        return r.text();
      }).then(html => {
        if (!html) throw new Error('empty');
        const replaced = replaceDrawerHtml(html);
        if (!replaced) throw new Error('no-drawer-in-html');
        return html;
      }));
    }, Promise.reject());
  }
  bundleForms.forEach(form => {
    form.addEventListener('click', function (e) {
      e.preventDefault();

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return console.error('variant id missing');
      const variant_id = variantInput.value;
      const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || 1);
      const selling_plan = form.querySelector('input[name="selling_plan"]')?.value || null;
      
      // Check for addon product checkbox
      const formId = String(form.id || '');
      let sectionId = '';
      if (formId && formId.includes('product-form-')) {
        sectionId = formId.replace('product-form-', '');
      } else {
        const widgetId = form.closest('.custom-frequency-widget')?.id || '';
        if (widgetId && widgetId.includes('shopify-section-')) {
          sectionId = String(widgetId).replace('shopify-section-', '');
        }
      }
      const addonCheckbox = sectionId 
        ? document.querySelector(`#addon-product-checkbox-${sectionId}:checked`)
        : form.closest('.custom-frequency-widget')?.querySelector('.addon-product-checkbox:checked');
      const items = [{
        id: parseInt(variant_id, 10),
        quantity: quantity
      }];
      if (selling_plan) {
        items[0].selling_plan = selling_plan;
      }
      
      // Add addon product if checkbox is checked
      if (addonCheckbox) {
        const addonVariantId = addonCheckbox.dataset.variantId;
        if (addonVariantId) {
          const addonItem = {
            id: parseInt(addonVariantId, 10),
            quantity: 1
          };
          const addonSupportsSubscription = addonCheckbox.dataset.subscriptionEnabled === 'true';
          if (addonSupportsSubscription && selling_plan) {
            addonItem.selling_plan = selling_plan;
          }
          items.push(addonItem);
        }
      }
      
      const submitButton = form.querySelector('[data-bundle-submit]');
      const originalText = submitButton ? submitButton.innerHTML : null;

      if (submitButton) {
        submitButton.innerHTML = 'Adding...';
        submitButton.disabled = true;
        setTimeout(() => {
          submitButton.innerHTML = originalText;
          submitButton.disabled = false;
        }, 1000);
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items
        })
      })
        .then(res => {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          try { updateCartCount(cart.item_count || 0); } catch (e) {}
          const possibleFns = [
            'updateCartDrawer', 'renderCart', 'openCartDrawer', 'refreshCartDrawer', 'window.ShopifyCartRefresh'
          ];
          let handled = false;
          for (const name of possibleFns) {
            const fn = window[name];
            if (typeof fn === 'function') {
              try {
                fn(cart);
                handled = true;
                break;
              } catch (err) {
                try { fn(); handled = true; break; } catch (e) {}
              }
            }
          }
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          } catch (err) {}
          return tryFetchDrawerHtml()
            .catch(() => {
              return Promise.resolve(null);
            })
            .then(() => cart);
        })
        .then(cart => {
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            const sel = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, .drawer--cart');
            if (sel) {
              sel.classList.add('active', 'is-open');
            }
          }
        })
        .catch(err => {
          console.error('bundle add error:', err);
          window.location.href = `/cart/add?items[][id]=${variant_id}&items[][quantity]=${quantity}&items[][selling_plan]=${selling_plan}&return_to=/checkout`;
        });
    });
  });
};
window.bundleCheckout();

var headings = document.querySelectorAll('.accordion summary');

headings.forEach(function(heading) {
  heading.addEventListener('click', function(event) {
    event.preventDefault();
    const parentDetail = this.closest('details');

    var description = this.nextElementSibling;
    if (description.classList.contains('show')) {
      description.style.maxHeight = '100%'; 
      setTimeout(function() {
        description.style.maxHeight = '0'; 
        parentDetail.removeAttribute('open', true);
      }, 10);

      description.classList.remove('show');
      parentDetail.removeAttribute('open', true);
    } else {
      description.classList.add('show');
      parentDetail.setAttribute('open', true);
      description.style.maxHeight = '0';

      setTimeout(function() {
        description.style.maxHeight = '100%'; 
      }, 10); 

      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
});





// Popup

document.querySelectorAll('.custom-open-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.id.split('-')[1];
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.add('open');
      
        const video = popup.querySelector('video'); // Select the video inside the popup
        if (video) {
            video.play();
        }
    });
});

document.querySelectorAll('.custom-close-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.getAttribute('data-popup');
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.remove('open');
      
        const video = popup.querySelector('video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    });
});



// Review video

document.querySelectorAll('.play_video').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.parentElement.querySelector('video');
        const parent = this.closest('.review_img_video');

        if (video) {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            video.addEventListener('play', function() {
                parent.classList.add('playing');
            });
            video.addEventListener('pause', function() {
                parent.classList.remove('playing');
            });
        } else {
            parent.classList.toggle('playing');
        }

        if (parent && !parent.classList.contains('played')) {
            parent.classList.add('played');
        }
    });
});






// Tabs

document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            const tabId = this.getAttribute('data-tab');
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabContents.forEach(content => {
                content.classList.remove('active');
                content.style.display = 'none';
            });
            this.classList.add('active');
            const activeContent = document.getElementById(`tab-${tabId}`);
            activeContent.style.display = 'block';
            setTimeout(() => activeContent.classList.add('active'), 10);
        });
    });
});



// After / Before
// var MyComparison = new slimBeforeAfter();
// const tabButtonsnew = document.querySelectorAll('.tab-button');

// tabButtonsnew.forEach(function(button) {
//   button.addEventListener('click', function () {
//     MyComparison.refresh();
//   });
// });

// ------- Landing Page scrollToBundleFeature button -------
function scrollToBundleFeature() {
  const targetSection = document.querySelector('.bundle-feature-product');
  if (targetSection) {
    window.scroll({
      top: targetSection.offsetTop,
      behavior: 'smooth'
    });
  }
}

document.querySelectorAll('.offer-scroll-btn').forEach(btn => {
  btn.addEventListener('click', scrollToBundleFeature);
});

window.addEventListener('resize', () => {
  // scrollToBundleFeature();
});


// Inject additional text in Recharge customer portal
const rc_login_ele = document.querySelector('.rc-login');
if(rc_login_ele){
  const additional_text = window.strings.recharge_customer_portal.additional_text;
  if(additional_text != '' || additional_text != null){
    const temp = `<span class="cs-additional-recharge-text" style="font-size: 14px;">${additional_text}</span>`;
    rc_login_ele.insertAdjacentHTML('beforeend', temp);
  }
}

// ================== Function to manage the selected plan price and strikethrough price ==================

// Function to fix sticky cart elements state for premium plans
function fixStickyCartState() {
  // Prefer the checked radio in the active tab so sticky cart matches visible content
  const activeTabContent = document.querySelector('.bundle-tab__content.active');
  const checkedRadios = activeTabContent
    ? activeTabContent.querySelectorAll('.plan-selector__input:checked')
    : document.querySelectorAll('.bundle-alt .plan-selector__input:checked, .product-info__block .plan-selector__input:checked');
  const radiosToCheck = checkedRadios.length ? checkedRadios : document.querySelectorAll('.bundle-alt .plan-selector__input:checked, .product-info__block .plan-selector__input:checked');
  let isPremiumSelected = false;
  radiosToCheck.forEach(radio => {
    const isPremium = radio.classList.contains('plan-premium') || 
                      radio.closest('.bundle-tab__description')?.classList.contains('plan-premium') ||
                      radio.matches('.plan-premium');
    if (isPremium) isPremiumSelected = true;
    const stickyATCoriginal = document.querySelector('.quick-cart-wrapper .price-regular');
    if (stickyATCoriginal && isPremium) {
      stickyATCoriginal.classList.remove('hidden');
    }
  });
  const stickyATCStrikethrough = document.querySelector('.quick-cart-wrapper .price-sale');
  if (stickyATCStrikethrough && isPremiumSelected) {
    stickyATCStrikethrough.classList.remove('price-non-discounted');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initPlanSelectors();
  initTabButtons();
  initSelectedRadio();
  initDescriptionSelection();
  initFirstRadioChecked();
  setTimeout(initFirstRadioChecked, 50);
  window.upadtePrice();
  
  // Fix sticky cart state after a short delay to ensure elements are ready
  setTimeout(function() {
    fixStickyCartState();
  }, 100);
  
  setTimeout(function() {
    fixStickyCartState();
  }, 500);

  document.querySelectorAll('.bundle-alt .bundle-tab__description').forEach(desc => {
    desc.addEventListener('click', function(e) {
      if (e.target.classList.contains('plan-selector__input')) return;
      const radio = desc.querySelector('.plan-selector__input');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});

// Also run on window load to catch any elements that load after DOMContentLoaded
window.addEventListener('load', function() {
  setTimeout(function() {
    fixStickyCartState();
  }, 100);
});

function initFirstRadioChecked() {
  const tabContents = document.querySelectorAll('.bundle-alt .bundle-tab__content, .product-info__block .bundle-tab__content');
  tabContents.forEach(tabContent => {
    // Check if there's already a checked radio (preserve pre-selected state, especially for plan-premium)
    const alreadyChecked = tabContent.querySelector('.plan-selector__input:checked');
    
    if (!alreadyChecked) {
      // Only reset if no radio is checked
      const allRadios = tabContent.querySelectorAll('.plan-selector__input');
      allRadios.forEach(radioInput => {
        radioInput.checked = false;
        const radioParent = radioInput.closest('.bundle-tab__description');
        if (radioParent) {
          radioParent.classList.remove('selected');
        }
      });

      const firstRadio = tabContent.querySelector('.plan-selector__input');
      if (firstRadio) {
        firstRadio.checked = true;
        updateVariantId(firstRadio);
        updatePriceDisplay(firstRadio);
        const firstDescription = firstRadio.closest('.bundle-tab__description');
        if (firstDescription) {
          firstDescription.classList.add('selected');
        }
      }
    } else {
      // Radio is already checked, just update the display to ensure correct state
      updateVariantId(alreadyChecked);
      updatePriceDisplay(alreadyChecked);
      const checkedDescription = alreadyChecked.closest('.bundle-tab__description');
      if (checkedDescription) {
        checkedDescription.classList.add('selected');
      }
    }
  });
  // Sync sticky cart from active tab only so premium selection is not overwritten by other tabs
  const activeTab = document.querySelector('.bundle-tab__content.active');
  const activeTabCheckedRadio = activeTab?.querySelector('.plan-selector__input:checked');
  if (activeTabCheckedRadio) {
    updatePriceDisplay(activeTabCheckedRadio);
  }
}

function initPlanSelectors() {
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('plan-selector__input') && e.target.checked) {
      updatePriceDisplay(e.target);
      updateDescriptionSelection(e.target);
      updateVariantId(e.target);
      const tabContent = e.target.closest('.bundle-tab__content');
      const buyButton = tabContent?.querySelector('.bundle-tab__buy-button .button_text');
      const planDescription = e.target.closest('.bundle-tab__description');
      if (buyButton && planDescription) {
        const buttonLabel = planDescription.getAttribute('data-button-label');
        if (buttonLabel) {
          buyButton.textContent = buttonLabel;
        }
      }
    }
  });
}

function initTabButtons() {
  const tabButtons = document.querySelectorAll('.bundle-alt .bundle-tab__button, .product-info__block .bundle-tab__button');
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      const parentContext = this.closest('.bundle-alt, .product-info__block');
      const tabContent = parentContext?.querySelector(`[data-tab-content="${tabId}"]`);
      const activeRadio = tabContent?.querySelector('.plan-selector__input:checked');
      if (activeRadio) {
        updatePriceDisplay(activeRadio);
      }
      activeRadio?.closest('.bundle-tab__description')?.classList.add('selected');
      window.upadtePrice();
    });
  });
}

function initSelectedRadio() {
  window.getSelectedRadio = function() {
    const selectedRadio = document.querySelector('.bundle-alt .plan-selector__input:checked, .product-info__block .plan-selector__input:checked');
    if (selectedRadio) {
      updatePriceDisplay(selectedRadio);
    }
  };
  window.getSelectedRadio();
}

function initDescriptionSelection() {
  document.querySelectorAll('.bundle-alt .plan-selector__input:checked, .product-info__block .plan-selector__input:checked').forEach(radio => {
    radio.closest('.bundle-tab__description')?.classList.add('selected');
  });
}

function updatePriceDisplay(radioElement) {
  if (!radioElement) return;
  
  const price = radioElement.getAttribute('data-price');
  const tabContent = radioElement.closest('.bundle-tab__content');
  const tabPriceRegular = tabContent?.querySelector('.tab-price-regular');
  const parentContext = radioElement.closest('.bundle-alt, .product-info__block');
  const strikethroughPrices = parentContext?.querySelectorAll('.bundle-tab__footer .bundle-tab__price.strikethrough') || [];
  const priceDiscounted = parentContext?.querySelectorAll('.bundle-tab__footer .price-discounted') || [];
  
  if (tabPriceRegular) {
    tabPriceRegular.innerHTML = price;
  }

  // Check for plan-premium class - check both the radio and its parent description
  const isPremium = radioElement.classList.contains('plan-premium') || 
                    radioElement.closest('.bundle-tab__description')?.classList.contains('plan-premium') ||
                    radioElement.matches('.plan-premium');
  
  // Handle strikethrough prices
  strikethroughPrices.forEach(element => {
    if (isPremium) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  });
  
  // Handle sticky cart elements with null checks
  const stickyATCStrikethrough = document.querySelector('.quick-cart-wrapper .price-sale');
  console.log('isPremium', isPremium);
  if (stickyATCStrikethrough) {
    if (isPremium) {
      stickyATCStrikethrough.classList.remove('price-non-discounted');
    } else {
      stickyATCStrikethrough.classList.add('price-non-discounted');
    }
  }
  
  const stickyATCoriginal = document.querySelector('.quick-cart-wrapper .price-regular');
  if (stickyATCoriginal) {
    // Explicitly remove hidden if premium, add if not premium
    if (isPremium) {
      stickyATCoriginal.classList.remove('hidden');
    } else {
      stickyATCoriginal.classList.add('hidden');
    }
  }
  
  // Handle price discounted elements
  priceDiscounted.forEach(element => {
    if (isPremium) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  });
}

function updateDescriptionSelection(radioElement) {
  const parentContext = radioElement.closest('.bundle-alt, .product-info__block');
  parentContext?.querySelectorAll('.bundle-tab__description.selected').forEach(el => {
    el.classList.remove('selected');
  });
  
  const description = radioElement.closest('.bundle-tab__description');
  if (description) {
    description.classList.add('selected');
  }
}

function updateVariantId(radioElement) {
  const variantId = radioElement.getAttribute('data-variant');
  const sellingPlanId = radioElement.getAttribute('data-selling-plan');
  const tabContent = radioElement.closest('.bundle-tab__content');
  const form = tabContent?.querySelector('[data-bundle-form]');
  const variantInput = form?.querySelector('input[name="id"]');
  const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
  
  if (variantInput && variantId) {
    variantInput.value = variantId;
  }
  
  if (sellingPlanInput) {
    if (radioElement.classList.contains('plan-regular')) {
      sellingPlanInput.value = '';
    } else {
      sellingPlanInput.value = sellingPlanId || '';
    }
  }
}

window.upadtePrice = function () {
  console.log('upadtePrice function called');
  
  const rechargeWidget = document.querySelector('.custom-recharge-widget');
  const hasBundleFeature = document.querySelector('.bundle-tabs') || document.querySelector('.bundle-tab__button');
  
  if (hasBundleFeature) {
    const priceElementRegular = document.querySelector('.product #product_custom_price_regular');
    const stickyATCRegular = document.querySelector('.quick-cart-wrapper .price-regular');
    const priceElementSale = document.querySelector('.product #product_custom_price_sale');
    const stickyATCSale = document.querySelector('.quick-cart-wrapper .price-sale');
    
    const activeTabPrice = document.querySelector('.bundle-tab__content.active .price-discounted') ||
                          document.querySelector('.bundle-tab__content.active .tab-price-regular') ||
                          document.querySelector('.bundle-tab__content.active .bundle-tab__price:not(.strikethrough)');
    
    const activeTabOriginalPrice = document.querySelector('.bundle-tab__content.active .bundle-tab__price.strikethrough') ||
                                  document.querySelector('.bundle-tab__content.active .bundle-tab__price[class*="strikethrough"]');
    
    console.log('activeTabPrice', activeTabPrice);
    console.log('activeTabOriginalPrice', activeTabOriginalPrice);
    console.log('activeTabPrice found:', !!activeTabPrice, 'activeTabOriginalPrice found:', !!activeTabOriginalPrice);
    
    if (activeTabPrice) {
      console.log('activeTabPrice content:', activeTabPrice.textContent);
    }
    
    if (priceElementRegular && activeTabPrice) {
      let cleanPrice = activeTabPrice.textContent.trim();
      cleanPrice = cleanPrice.replace(/\s+(GBP|USD|EUR|CAD|AUD|JPY|INR)\s*$/i, '');
      const currentCurrency = window.Shopify?.currency?.active || 'GBP';
      if (currentCurrency === 'GBP') {
        cleanPrice = cleanPrice + ' GBP';
      }
      
      priceElementRegular.removeAttribute('data-widget-controlled');
      priceElementRegular.textContent = cleanPrice;
      stickyATCRegular.textContent = cleanPrice;
      console.log('Updated regular price to:', cleanPrice);
    }
    
    if (priceElementSale && activeTabOriginalPrice) {
      let cleanOriginalPrice = activeTabOriginalPrice.textContent.trim();
      cleanOriginalPrice = cleanOriginalPrice.replace(/\s+(GBP|USD|EUR|CAD|AUD|JPY|INR)\s*$/i, '');
      const currentCurrency = window.Shopify?.currency?.active || 'GBP';
      if (currentCurrency === 'GBP') {
        cleanOriginalPrice = cleanOriginalPrice + ' GBP';
      }
     
      priceElementSale.removeAttribute('data-widget-controlled');
      priceElementSale.textContent = cleanOriginalPrice;
      stickyATCSale.textContent = cleanOriginalPrice;
      priceElementSale.style.display = 'inline';
    }
    if (!activeTabPrice) {
      console.log('Could not find active tab price element');
    }
  }
}

function syncStickyCartPriceFromFrequencyWidget() {
  const widget = document.querySelector('.custom-frequency-widget');
  if (!widget) return;
  const checkedInput = widget.querySelector('.frequency-input[type="radio"]:checked');
  if (!checkedInput) return;
  const activePlanItem = checkedInput.closest('.plan-frequency.plan-item');
  if (!activePlanItem) return;
  const priceDiscounted = activePlanItem.querySelector('.price-regular.price-discounted, .price-discounted');
  const strikethroughEl = activePlanItem.querySelector('.plan-sale.price-strikethrough, .price-strikethrough');
  const stickyRegular = document.querySelector('.quick-cart-wrapper .price-regular');
  const stickySale = document.querySelector('.quick-cart-wrapper .price-sale');
  if (priceDiscounted && stickyRegular) {
    stickyRegular.textContent = priceDiscounted.textContent.trim();
    stickyRegular.classList.remove('hidden');
  }
  if (stickySale) {
    if (checkedInput.classList.contains('one-time-item')) {
      stickySale.textContent = '';
      stickySale.classList.add('price-non-discounted');
      stickySale.style.display = 'none';
    } else {
      if (strikethroughEl) {
        stickySale.textContent = strikethroughEl.textContent.trim();
      }
      stickySale.classList.remove('price-non-discounted');
      stickySale.style.display = '';
    }
  }
}

function updateProductPriceDisplayForPlan() {
  const checkedRadio = document.querySelector('.custom-frequency-widget input[type="radio"]:checked');
  if (!checkedRadio) return;
  const activePlanItem = checkedRadio.closest('.plan-frequency.plan-item');
  if (!activePlanItem) return;
  const productRegularEl = document.querySelector('.product #product_custom_price_regular');
  const priceSaleContainer = document.querySelector('.product .price__container .price__sale');
  if (!productRegularEl) return;

  const isOneTime = checkedRadio.classList.contains('one-time-item');
  const priceEl = activePlanItem.querySelector('.price-regular.price-discounted');
  const priceText = priceEl ? priceEl.textContent.trim() : '';

  if (isOneTime) {
    productRegularEl.textContent = priceText;
    if (priceSaleContainer) priceSaleContainer.style.display = 'none';
  } else {
    productRegularEl.textContent = priceText;
    if (priceSaleContainer) priceSaleContainer.style.display = '';
    const strikethroughEl = activePlanItem.querySelector('.plan-sale.price-strikethrough, .price-strikethrough');
    const saleEl = document.querySelector('.product #product_custom_price_sale');
    if (strikethroughEl && saleEl) saleEl.textContent = strikethroughEl.textContent.trim();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const frequencyInputs = document.querySelectorAll('input[name="subscription-frequency"]');
  frequencyInputs.forEach(input => {
    input.addEventListener('change', function () {
      const value = this.classList.contains('one-time-item') ? '' : (this.dataset.sellingPlanId || '');
      document.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
        el.value = value;
      });
      syncStickyCartPriceFromFrequencyWidget();
      updateProductPriceDisplayForPlan();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const planItems = document.querySelectorAll('.plan-frequency.plan-item input[type="radio"]');

  function updateActiveState() {
    document.querySelectorAll('.plan-frequency.plan-item').forEach(item => {
      item.classList.remove('active');
    });

    const checkedInput = document.querySelector('.plan-frequency.plan-item input[type="radio"]:checked');
    if (checkedInput) {
      checkedInput.closest('.plan-frequency.plan-item').classList.add('active');
    }
    if (checkedInput) {
      const value = checkedInput.classList.contains('one-time-item') ? '' : (checkedInput.dataset.sellingPlanId || '');
      document.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
        el.value = value;
      });
    }
    syncStickyCartPriceFromFrequencyWidget();
    updateProductPriceDisplayForPlan();
  }

  function initBundleTabButtons() {
    document.querySelectorAll('.bundle-tab__button').forEach(button => {
      button.addEventListener('click', () => {
        const parent = button.closest('.button-badge-container');
        if (!parent) return;

        const targetId = parent.getAttribute('data-id');
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;
        
        document.querySelectorAll('.bundle-tab__button').forEach(btn => {
          btn.classList.remove('active');
        });
        button.classList.add('active');

        document.querySelectorAll('.plan-frequency').forEach(el => {
          el.classList.remove('active');
          el.classList.add('hidden');
        });

        targetElement.classList.remove('hidden');
        targetElement.classList.add('active');

        const frequencyInput = targetElement.querySelector('input.frequency-input[type="radio"]');

        if (frequencyInput) {
          frequencyInput.checked = true;
          frequencyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncSellingPlanFromCheckedRadio();
        updateProductPriceDisplayForPlan();
      });
    });
  }

  updateActiveState();
  initBundleTabButtons();
  planItems.forEach(input => {
    input.addEventListener('change', updateActiveState);
  });

  function syncSellingPlanFromCheckedRadio() {
    const checked = document.querySelector('.custom-frequency-widget .frequency-input[type="radio"]:checked') || document.querySelector('input[name="subscription-frequency"]:checked');
    if (!checked) return;
    const value = checked.classList.contains('one-time-item') ? '' : (checked.dataset.sellingPlanId || '');
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      input.value = value;
    });
  }
  syncSellingPlanFromCheckedRadio();
  syncStickyCartPriceFromFrequencyWidget();
  updateProductPriceDisplayForPlan();

  setTimeout(function () {
    syncSellingPlanFromCheckedRadio();
    syncStickyCartPriceFromFrequencyWidget();
    updateProductPriceDisplayForPlan();
  }, 0);
});

window.addEventListener('load', function () {
  const checked = document.querySelector('.custom-frequency-widget .frequency-input[type="radio"]:checked') ||
                  document.querySelector('input[name="subscription-frequency"]:checked');
  if (checked) {
    const value = checked.classList.contains('one-time-item') ? '' : (checked.dataset.sellingPlanId || '');
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      input.value = value;
    });
  }
  updateProductPriceDisplayForPlan();
});

window.rechargeCheckout = function() {
  const checkoutForms = document.querySelectorAll('.custom-frequency-widget form');
  
  checkoutForms.forEach(form => {
    const submitButton = form.querySelector('.product-form__submit');
    
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        e.preventDefault();
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
        
        if (!variantInput) {
          console.error('Variant ID input not found');
          return;
        }
        
        if (!sellingPlanInput) {
          console.error('Selling plan input not found');
          return;
        }
        
        const variant_id = variantInput.value;
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        const selling_plan = sellingPlanInput.value;
        
        // Check for addon product checkbox
        const formId = String(form.id || '');
        let sectionId = '';
        if (formId && formId.includes('product-form-')) {
          sectionId = formId.replace('product-form-', '');
        } else {
          const widgetId = form.closest('.custom-frequency-widget')?.id || '';
          if (widgetId && widgetId.includes('shopify-section-')) {
            sectionId = String(widgetId).replace('shopify-section-', '');
          }
        }
        const addonCheckbox = sectionId 
          ? document.querySelector(`#addon-product-checkbox-${sectionId}:checked`)
          : form.closest('.custom-frequency-widget')?.querySelector('.addon-product-checkbox:checked');
        const items = [{
          id: parseInt(variant_id, 10),
          quantity: quantity
        }];
        if (selling_plan) {
          items[0].selling_plan = selling_plan;
        }
        
        // Add addon product if checkbox is checked
        if (addonCheckbox) {
          const addonVariantId = addonCheckbox.dataset.variantId;
          if (addonVariantId) {
            const addonItem = {
              id: parseInt(addonVariantId, 10),
              quantity: 1
            };
            const addonSupportsSubscription = addonCheckbox.dataset.subscriptionEnabled === 'true';
            if (addonSupportsSubscription && selling_plan) {
              addonItem.selling_plan = selling_plan;
            }
            items.push(addonItem);
          }
        }
        
        const originalText = submitButton.innerHTML;
        submitButton.innerHTML = 'Adding...';
        submitButton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items
          })
        })
        .then(response => response.json().then(data => {
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        }))
        .then(() => fetch('/cart.js').then(res => res.json()))
        .then(cart => {
          const count = cart.item_count || 0;

          const countSelectors = ['[data-cart-count]', '.cart-count', '.header__cart-count', '#CartCount'];
          countSelectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(el => {
              el.textContent = count;
              if (el.dataset) el.dataset.count = count;
            });
          });
          const cartIconBubble = document.querySelector('#cart-icon-bubble');
          if (cartIconBubble) {
            let bubble = cartIconBubble.querySelector('.cart-count-bubble');
            if (count > 0) {
              if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                const span = document.createElement('span');
                span.setAttribute('aria-hidden', 'true');
                bubble.appendChild(span);
                cartIconBubble.appendChild(bubble);
              }
              const numSpan = bubble.querySelector('span[aria-hidden="true"]');
              if (numSpan) numSpan.textContent = count;
            } else if (bubble) {
              const numSpan = bubble.querySelector('span[aria-hidden="true"]');
              if (numSpan) numSpan.textContent = '0';
            }
          }

          // Refresh cart drawer content
          const cartUrl = (typeof routes !== 'undefined' && routes && routes.cart_url) ? routes.cart_url : '/cart';
          return fetch(`${cartUrl}?section_id=cart-drawer`)
            .then(res => res.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              selectors.forEach(selector => {
                const target = document.querySelector(selector);
                const source = doc.querySelector(selector);
                if (target && source) target.replaceWith(source);
              });
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.classList.remove('is-empty');
                cartDrawer.classList.toggle('is-empty', count === 0);
                const drawerItems = cartDrawer.querySelector('cart-drawer-items');
                if (drawerItems) drawerItems.classList.remove('is-empty');
                const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
                if (innerEmpty && count > 0) innerEmpty.remove();
                const drawerInner = cartDrawer.querySelector('.drawer__inner');
                if (drawerInner && count > 0) drawerInner.classList.remove('is-empty');
              }
            })
            .then(() => cart);
        })
        .then(() => {
          // Open cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, .drawer--cart');
            if (drawer) drawer.classList.add('active', 'is-open');
          }
          document.body.classList.add('overflow-hidden');
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          let fallbackUrl = `/cart/add?items[][id]=${variant_id}&items[][quantity]=${quantity}`;
          if (selling_plan) {
            fallbackUrl += `&items[][selling_plan]=${selling_plan}`;
          }
          if (addonCheckbox) {
            const addonVariantId = addonCheckbox.dataset.variantId;
            if (addonVariantId) {
              fallbackUrl += `&items[][id]=${addonVariantId}&items[][quantity]=1`;
              const addonSupportsSubscription = addonCheckbox.dataset.subscriptionEnabled === 'true';
              if (addonSupportsSubscription && selling_plan) {
                fallbackUrl += `&items[][selling_plan]=${selling_plan}`;
              }
            }
          }
          fallbackUrl += '&return_to=/cart';
          window.location.href = fallbackUrl;
        })
        .finally(() => {
          submitButton.innerHTML = originalText;
          submitButton.disabled = false;
        });
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.rechargeCheckout();
});

(function () {
  function syncPriceFromRadio(radio) {
    if (!radio.checked) return;

    const bar = radio.closest('.rapi-bundles__bar');
    if (!bar) return;
    const rapiMoney = bar.querySelector('.rapi-bundles__bar-price .rapi-money');
    const rapiParent = bar.closest('.rapi-bundles__bar-pricing-column');
    const rapiMoneyCompare = bar.querySelector('.rapi-bundles__bar-full-price .rapi-money');
    const compareMoneyRapi = rapiMoneyCompare?.textContent;

    const stickyMoney = document.querySelector('.sticky-cart-container .price-regular .money');
    const compareMoneyParent = document.querySelector('.sticky-cart-container .price-sale.price-original');
    const stickyCompareMoney = compareMoneyParent.querySelector('.sticky-cart-container .price-sale.price-original .money');

    if (rapiMoney && stickyMoney) {
      stickyMoney.innerHTML = rapiMoney.innerHTML;
    } 

    if (rapiMoneyCompare && stickyCompareMoney) {
      compareMoneyParent.classList.remove('hidden');
      stickyCompareMoney.innerHTML = rapiMoneyCompare.innerHTML;
    }
    
    if (rapiMoneyCompare == null) {
      compareMoneyParent.classList.add('hidden');
    } else {
      compareMoneyParent.classList.remove('hidden');
    }

    if (compareMoneyParent && compareMoneyRapi) {
      compareMoneyParent.textContent = compareMoneyRapi;
      // compareMoneyParent.classList.remove('hidden');
    }
  }

  document.addEventListener('click', function (e) {
    const radio = e.target.closest('input[type="radio"]');
    if (!radio) return;

    if (radio.closest('.rapi-bundles__bar')) {
      setTimeout(() => syncPriceFromRadio(radio), 0);
    }
  });

  document.addEventListener('change', function (e) {
    const radio = e.target;
    if (
      radio.matches('input[type="radio"]') &&
      radio.closest('.rapi-bundles__bar')
    ) {
      syncPriceFromRadio(radio);
    }
  });
})();

(function syncSellingPlanUntilRcWrapper() {
  var guardUpdating = false;

  function getSubscriptionPriceForDisplay() {
    var checkedRadio = document.querySelector('.custom-frequency-widget input[type="radio"]:checked');
    if (!checkedRadio || checkedRadio.classList.contains('one-time-item')) return null;
    var activePlanItem = checkedRadio.closest('.plan-frequency.plan-item');
    if (!activePlanItem) return null;
    var activeRadioPrice = activePlanItem.querySelector('.price-regular.price-discounted');
    return activeRadioPrice ? activeRadioPrice.textContent.trim() : null;
  }

  function setSellingPlanAndRegularPrice(checkedRadio) {
    if (!checkedRadio) return;
    var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && !checkedRadio.classList.contains('one-time-item')) {
      sellingPlanInput.value = checkedRadio.dataset.sellingPlanId || '';
    }
    var expectedPrice = getSubscriptionPriceForDisplay();
    if (expectedPrice) {
      var productRegularEl = document.querySelector('.product #product_custom_price_regular');
      if (productRegularEl) {
        guardUpdating = true;
        productRegularEl.textContent = expectedPrice;
        setTimeout(function() { guardUpdating = false; }, 0);
      }
    }
  }

  function attachPriceGuardObserver(el) {
    if (el._frequencyPriceGuardAttached) return;
    el._frequencyPriceGuardAttached = true;
    var observer = new MutationObserver(function() {
      if (guardUpdating) return;
      var expected = getSubscriptionPriceForDisplay();
      if (expected == null) return;
      var current = (el.textContent || '').trim();
      if (current === expected) return;
      guardUpdating = true;
      el.textContent = expected;
      setTimeout(function() { guardUpdating = false; }, 0);
    });
    observer.observe(el, { characterData: true, characterDataOldValue: true, childList: true, subtree: true });
  }

  function ensurePriceGuard() {
    var productRegularEl = document.querySelector('.product #product_custom_price_regular');
    if (productRegularEl) attachPriceGuardObserver(productRegularEl);
  }

  var intervalMs = 200;
  var intervalId = setInterval(function() {
    ensurePriceGuard();
    var rcWrapper = document.querySelector('.rc-container-wrapper');
    if (rcWrapper) {
      clearInterval(intervalId);
      setTimeout(function() {
        var checkedRadio = document.querySelector('.custom-frequency-widget input[type="radio"]:checked');
        setSellingPlanAndRegularPrice(checkedRadio);
        if (typeof updateProductPriceDisplayForPlan === 'function') updateProductPriceDisplayForPlan();
        ensurePriceGuard();
      }, 500);
      return;
    }
    var checkedRadio = document.querySelector('.custom-frequency-widget input[type="radio"]:checked');
    setSellingPlanAndRegularPrice(checkedRadio);
    if (typeof updateProductPriceDisplayForPlan === 'function') updateProductPriceDisplayForPlan();
  }, intervalMs);
})();

function handleRapiWidget() {
  const rapiWidget = document.querySelector('.rapi-bundles__bars');
  if (!rapiWidget) return false;

  const checkedInputRapi = rapiWidget.querySelector('.rapi-bundles__bar input[type="radio"]:checked');
  if (!checkedInputRapi) return false;
  
  const activeBar = checkedInputRapi.closest('.rapi-bundles__bar');
  if (!activeBar) return false;
  
  const priceEl = activeBar.querySelector('.rapi-bundles__bar-price');
  if (!priceEl) return false;

  const comparePriceEl = activeBar.querySelector('.rapi-bundles__bar-full-price');
  if (!comparePriceEl) return false;
  
  const price = priceEl.textContent.trim();
  const comparePrice = comparePriceEl.textContent.trim();

  const priceWrapper = document.querySelector('#product_custom_price_regular');

  const stickyPrice = document.querySelector('.sticky-cart-container .price-regular.price-discounted span');
  const stickyComparePrice = document.querySelector('.sticky-cart-container .price-sale.price-original.price-strikethrough');

  setTimeout(() => {
    const priceEleRapiRegular = priceEl.querySelector('.rapi-money').innerHTML;
    if (priceEleRapiRegular && stickyPrice) {
      stickyPrice.textContent = priceEleRapiRegular;
    }

    // setTimeout(() => {
    // if (priceWrapper) {
    //     priceWrapper.textContent = priceEleRapiRegular;
    //   }
    // }, 4200);

  }, 1000);
  
  if (stickyPrice && price) {
    stickyPrice.textContent = price;
  }

  setTimeout(() => {
    const priceEleRapiCompare = comparePriceEl.querySelector('.rapi-money').innerHTML;
    if (stickyComparePrice && priceEleRapiCompare) {
      stickyComparePrice.textContent = priceEleRapiCompare;
    }
  }, 1000);

  if (stickyComparePrice && comparePrice) {
    stickyComparePrice.textContent = comparePrice;
  }
  return true;
}

const observer = new MutationObserver((mutations, obs) => {
  const success = handleRapiWidget();
  if (success) {
    obs.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

window.addEventListener('load', function () {
  const hideVariantProduct = document.querySelector('.product.hide-variants');
  if (!hideVariantProduct) return;

  const optionSelector = hideVariantProduct.querySelector('.select__select');
  if (!optionSelector) return;

  optionSelector.querySelectorAll('option.hide-variant').forEach(option => {
    option.remove();
  });

  const activeOption = optionSelector.querySelector('option.active-variant');
  if (activeOption) {
    optionSelector.value = activeOption.value;
    optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
  } else if (optionSelector.options.length > 0) {
    optionSelector.selectedIndex = 0;
    optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

// One-time purchase selected by default
document.addEventListener('DOMContentLoaded', () => {
  if (!location.pathname.includes('/products/pheromone-moth-traps')) return;
  const selectOneTime = () => {
    const radio = document.querySelector('.rc-option__onetime input[type="radio"]');
    if (radio && !radio.checked) radio.click();
  };
  selectOneTime();
  const observer = new MutationObserver(selectOneTime);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
});